<div class="bg-white shadow-sm p-3 rounded mb-3">
  <div class="d-flex justify-content-between">
    <h6 class="line-2" style="max-width: 70%">
      {{ workshop.title }}
    </h6>
  </div>
  <div class="mt-3">
    <ng-icon name="lucideUser" class="me-2 text-secondary"></ng-icon>
    <span class="align-self-center"
      >{{ "trainingHist.labels.teacher" | translate }}:
      {{ workshop.teacherFullName }}</span
    >
  </div>
  <div class="mt-2 d-flex">
    <ng-icon name="lucideCalendar" class="me-2 text-secondary"></ng-icon>
    <span class="align-self-center"
      >{{ "trainingHist.labels.eventDate" | translate }}:
      {{ workshop.holdingDateJalali }}
      <span
        class="bg-warning p-1 rounded ms-2 align-self-center"
        style="text-wrap: nowrap"
        *ngIf="workshop.daysLeft > 0"
        >{{ workshop.daysLeft }} روز دیگر</span
      ></span
    >
  </div>
  <div class="mt-2">
    <ng-icon name="lucideLayers" class="me-2 text-secondary"></ng-icon>
    <span class="align-self-center"
      >{{ "trainingHist.labels.method" | translate }}:
      {{ workshop.holdingTypeTitle }}</span
    >
  </div>
  <div class="mt-2" *ngIf="workshop.locationTitle?.length">
    <ng-icon name="lucideMapPin" class="me-2 text-secondary"></ng-icon>
    <span class="align-self-center"
      >{{ "trainingHist.labels.location" | translate }}:
      {{ workshop.locationTitle }}</span
    >
  </div>
  <a
    class="btn btn-outline-success btn-block mt-3 ms-2"
    target="_blank"
    href="{{ workshop.googleCalendarNewEventUrl }}"
    *ngIf="workshop?.googleCalendarNewEventUrl"
  >
    <ng-icon name="lucidePlus" class="me-2"></ng-icon>
    {{ "labels.addToCalendar" | translate }}
  </a>
</div>
